<template>
  <section class="home light">
    <ArticleMastHead
      :cover_media="homeCoverMedia"
      :isHomePath="true"
      :isMainContent="false"
    >
      <template #homeSearchbar>
        <TheSearchbar :isHomePath="true" />
      </template>
    </ArticleMastHead>
    <!-- 首頁主視圖：全部內容與行事曆 -->
    <router-view name="homepageMainView"></router-view>
  </section>
</template>

<script>
import ArticleMastHead from "@/components/article/ArticleMastHead";
import TheSearchbar from "@/components/TheSearchbar";

export default {
  name: "home",
  data() {
    return {
      homeCoverMedia: {
        type: "image",
        isHomePath: true,
      },
    };
  },
  computed: {
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
  },
  // mounted() {
  //   if (this.isFestivalYear) {
  //     document.body.classList.add('light');
  //   }
  // },
  // destroyed() {
  //   if (this.isFestivalYear) {
  //     document.body.classList.remove('light');
  //   }
  // },
  components: {
    ArticleMastHead,
    TheSearchbar,
  },
};
</script>

<style lang="scss" scoped></style>
